var _defs, _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCapacity = function SvgCapacity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".capacitya,.capacityb,.capacityc{fill:#70717e;}.capacitya{opacity:0;}.capacityb{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "capacitya",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "capacityb",
    d: "M11.266,8.778a3.333,3.333,0,1,0-4.533,0L6.7,8.79A6,6,0,0,0,3,14.333.667.667,0,0,0,3.667,15H14.333A.667.667,0,0,0,15,14.333,6,6,0,0,0,11.3,8.79ZM7,6.333a2,2,0,1,1,2,2A2,2,0,0,1,7,6.333ZM9,9.667a4.667,4.667,0,0,0-4.619,4h9.238A4.667,4.667,0,0,0,9,9.667Z",
    transform: "translate(-1 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "capacityc",
    d: "M3.333,4a2.662,2.662,0,0,1,.889.152,3.993,3.993,0,0,0-.668,1.2,1.333,1.333,0,1,0,0,2.63c.013.038.029.082.047.128.165.446.453,1.223-.268,1.223a2,2,0,0,0-1.848,1.235c-.08.193-.12.316-.226.644-.059.183-.14.43-.259.788H.667A.667.667,0,0,1,0,11.333,3.334,3.334,0,0,1,1.467,8.571,2.667,2.667,0,0,1,3.333,4Z",
    transform: "translate(0 -1.333)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "capacityc",
    d: "M17.67,4.152a2.667,2.667,0,0,1,2.754,4.42,3.334,3.334,0,0,1,1.466,2.762.666.666,0,0,1-.666.667h-.333c-.119-.359-.2-.605-.259-.788-.106-.327-.146-.451-.226-.644a2,2,0,0,0-1.847-1.235c-.72,0-.432-.777-.268-1.223.017-.047.033-.09.047-.128a1.333,1.333,0,1,0,0-2.63A3.992,3.992,0,0,0,17.67,4.152Z",
    transform: "translate(-5.89 -1.333)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCapacity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/capacity.07ff8232.svg";
export { ForwardRef as ReactComponent };